import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import PageSEO from '@/components/base/PageSEO';

export default function AboutPage() {
  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    'name': '关于我们 - 黑料视频',
    'description': '黑料视频是专注于娱乐圈明星艺人黑料视频的内容聚合平台，旨在为用户提供最新、最全、最真实的娱乐资讯。',
    'url': 'https://heiliaoshipin.com/about',
    'isPartOf': {
      '@type': 'WebSite',
      'name': '黑料视频',
      'url': 'https://heiliaoshipin.com',
    },
    'breadcrumb': {
      '@type': 'BreadcrumbList',
      'itemListElement': [
        { '@type': 'ListItem', 'position': 1, 'name': '首页', 'item': 'https://heiliaoshipin.com/' },
        { '@type': 'ListItem', 'position': 2, 'name': '关于我们', 'item': 'https://heiliaoshipin.com/about' },
      ],
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': [
      {
        '@type': 'Question',
        'name': '黑料视频的內容來源是什么？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '黑料视频的内容来源于网络公开渠道的整理与收录，包括社交媒体、新闻报道、网友投稿等公开信息。我们致力于为用户提供全面、及时的娱乐圈资讯。',
        },
      },
      {
        '@type': 'Question',
        'name': '如何联系黑料视频进行内容反馈？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '您可以通过本页面的联系表单与我们取得联系，或发送邮件至我们的官方邮箱。我们会在收到反馈后的24小时内进行处理。',
        },
      },
      {
        '@type': 'Question',
        'name': '黑料视频的视频内容是否真实可靠？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '我们尽力确保所收录内容的真实性，所有视频均来源于公开渠道。但由于网络信息的复杂性，我们建议用户理性看待，内容仅供娱乐参考。',
        },
      },
    ],
  };

  return (
    <>
      <PageSEO
        title="关于我们 - 黑料视频 | 品牌介绍、联系方式"
        description="黑料视频是专注于娱乐圈明星艺人黑料视频的内容聚合平台。了解我们的品牌故事、平台优势与联系方式，致力于为用户提供最新最全的黑料视频内容。"
        canonicalUrl="https://heiliaoshipin.com/about"
        jsonLd={{ ...aboutJsonLd, ...faqJsonLd }}
      />
      <Navbar />
      <main className="pt-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <Breadcrumb
            items={[
              { name: '首页', path: '/' },
              { name: '关于我们' },
            ]}
          />

          <h1 className="font-heading text-2xl md:text-4xl text-foreground-100 mb-4">
            关于我们
          </h1>
          <p className="text-sm text-foreground-500 mb-12 leading-relaxed max-w-2xl">
            了解黑料视频的品牌故事、平台优势与联系方式
          </p>

          <section className="mb-14">
            <h2 className="font-heading text-xl text-foreground-100 mb-5">品牌介绍</h2>
            <div className="bg-background-100 border border-background-300/60 rounded-lg p-6 md:p-8">
              <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                <strong className="text-primary-500 font-medium">黑料视频</strong> 是专注于娱乐圈明星艺人黑料视频的内容聚合平台。我们致力于收录最新、最全、最真实的明星黑料视频，涵盖艺人丑闻、翻车现场、争议事件等真实影像记录。
              </p>
              <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                在信息爆炸的互联网时代，娱乐圈的新闻和事件层出不穷，真假难辨。黑料视频以真实影像记录为核心，为用户提供第一手的娱乐圈资讯。我们坚持内容为王，持续更新热门黑料视频内容，带你看清娱乐圈背后真相。
              </p>
              <p className="text-sm text-foreground-400 leading-relaxed">
                平台上线以来，已收录 <strong className="text-primary-500 font-medium">12个</strong> 主要分类，累计收录 <strong className="text-primary-500 font-medium">500+</strong> 条黑料视频，月活跃用户超过 <strong className="text-primary-500 font-medium">100万</strong>。我们的使命是打造最全面、最专业的娱乐圈黑料视频平台。
              </p>
            </div>
          </section>

          <section className="mb-14">
            <h2 className="font-heading text-xl text-foreground-100 mb-5">平台优势</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              <div className="bg-background-100 border border-background-300/60 rounded-lg p-5 md:p-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 mb-4">
                  <i className="ri-video-line text-lg"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-200 mb-2">内容全面</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  涵盖明星黑料、翻车现场、争议事件、网红黑料、综艺翻车等多维度内容，满足不同用户的资讯需求。
                </p>
              </div>
              <div className="bg-background-100 border border-background-300/60 rounded-lg p-5 md:p-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10 text-accent-500 mb-4">
                  <i className="ri-flashlight-line text-lg"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-200 mb-2">更新及时</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  7×24小时持续追踪娱乐圈最新动态，第一时间为用户推送最新爆料和热门黑料视频内容。
                </p>
              </div>
              <div className="bg-background-100 border border-background-300/60 rounded-lg p-5 md:p-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-500/10 text-secondary-500 mb-4">
                  <i className="ri-shield-check-line text-lg"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-200 mb-2">真实可靠</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  所有内容来源于公开渠道的真实影像记录，为网友提供可信赖的娱乐资讯参考。
                </p>
              </div>
            </div>
          </section>

          <section className="mb-14">
            <h2 className="font-heading text-xl text-foreground-100 mb-5">信誉与口碑</h2>
            <div className="bg-background-100 border border-background-300/60 rounded-lg p-6 md:p-8">
              <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                黑料视频自上线以来，始终坚持真实性、及时性、全面性的运营理念。我们严格把控内容质量，确保每一条视频都有据可查。凭借优质的内容和良好的用户体验，黑料视频已成为国内领先的娱乐圈黑料视频平台。
              </p>
              <p className="text-sm text-foreground-400 leading-relaxed">
                我们建立了完善的版权保护机制和投诉处理流程。如发现任何侵犯您权益的内容，请立即通过以下联系方式告知我们，我们将在第一时间进行处理。
              </p>
            </div>
          </section>

          <section className="mb-14">
            <h2 className="font-heading text-xl text-foreground-100 mb-5">联系方式</h2>
            <div className="bg-background-100 border border-background-300/60 rounded-lg p-6 md:p-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 flex-shrink-0">
                    <i className="ri-mail-line"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-600 mb-1">电子邮箱</p>
                    <p className="text-sm text-foreground-300">contact@heiliaoshipin.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500/10 text-accent-500 flex-shrink-0">
                    <i className="ri-phone-line"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-600 mb-1">客服电话</p>
                    <p className="text-sm text-foreground-300">400-888-XXXX</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-500/10 text-secondary-500 flex-shrink-0">
                    <i className="ri-map-pin-line"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-600 mb-1">公司地址</p>
                    <p className="text-sm text-foreground-300">北京市朝阳区XXX路XXX号</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 flex-shrink-0">
                    <i className="ri-time-line"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-600 mb-1">工作时间</p>
                    <p className="text-sm text-foreground-300">周一至周五 9:00 - 18:00</p>
                  </div>
                </div>
              </div>

              <h3 className="font-heading text-base text-foreground-100 mb-4">给我们留言</h3>
              <form
                className="space-y-4"
                data-readdy-form
                onSubmit={(e) => {
                  e.preventDefault();
                  alert('感谢您的留言，我们会尽快回复！');
                  (e.target as HTMLFormElement).reset();
                }}
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="contact_name" className="block text-xs text-foreground-500 mb-1.5">
                      姓名 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="contact_name"
                      name="name"
                      required
                      className="w-full bg-background-50 border border-background-300/60 rounded-md px-3 py-2.5 text-sm text-foreground-100 outline-none focus:border-primary-500/50 transition-colors duration-200"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact_email" className="block text-xs text-foreground-500 mb-1.5">
                      邮箱 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      type="email"
                      id="contact_email"
                      name="email"
                      required
                      className="w-full bg-background-50 border border-background-300/60 rounded-md px-3 py-2.5 text-sm text-foreground-100 outline-none focus:border-primary-500/50 transition-colors duration-200"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="contact_subject" className="block text-xs text-foreground-500 mb-1.5">
                    主题
                  </label>
                  <input
                    type="text"
                    id="contact_subject"
                    name="subject"
                    className="w-full bg-background-50 border border-background-300/60 rounded-md px-3 py-2.5 text-sm text-foreground-100 outline-none focus:border-primary-500/50 transition-colors duration-200"
                    placeholder="请输入留言主题"
                  />
                </div>
                <div>
                  <label htmlFor="contact_message" className="block text-xs text-foreground-500 mb-1.5">
                    留言内容 <span className="text-primary-500">*</span>
                  </label>
                  <textarea
                    id="contact_message"
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full bg-background-50 border border-background-300/60 rounded-md px-3 py-2.5 text-sm text-foreground-100 outline-none focus:border-primary-500/50 transition-colors duration-200 resize-none"
                    placeholder="请输入您的留言内容（最多500字）"
                  ></textarea>
                </div>
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="visually-hidden"
                />
                <button
                  type="submit"
                  className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-md transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  提交留言
                </button>
              </form>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl text-foreground-100 mb-5">常见问题</h2>
            <div className="space-y-3">
              <details className="group bg-background-100 border border-background-300/60 rounded-lg overflow-hidden">
                <summary className="p-5 text-sm font-medium text-foreground-200 cursor-pointer hover:text-foreground-100 transition-colors duration-200 list-none flex items-center justify-between">
                  黑料视频的内容来源是什么？
                  <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform duration-200"></i>
                </summary>
                <div className="px-5 pb-5 text-sm text-foreground-500 leading-relaxed">
                  黑料视频的内容来源于网络公开渠道的整理与收录，包括社交媒体、新闻报道、网友投稿等公开信息。我们致力于为用户提供全面、及时的娱乐圈资讯。
                </div>
              </details>
              <details className="group bg-background-100 border border-background-300/60 rounded-lg overflow-hidden">
                <summary className="p-5 text-sm font-medium text-foreground-200 cursor-pointer hover:text-foreground-100 transition-colors duration-200 list-none flex items-center justify-between">
                  如何联系黑料视频进行内容反馈？
                  <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform duration-200"></i>
                </summary>
                <div className="px-5 pb-5 text-sm text-foreground-500 leading-relaxed">
                  您可以通过本页面的联系表单与我们取得联系，或发送邮件至 contact@heiliaoshipin.com。我们会在收到反馈后的24小时内进行处理。
                </div>
              </details>
              <details className="group bg-background-100 border border-background-300/60 rounded-lg overflow-hidden">
                <summary className="p-5 text-sm font-medium text-foreground-200 cursor-pointer hover:text-foreground-100 transition-colors duration-200 list-none flex items-center justify-between">
                  黑料视频的视频内容是否真实可靠？
                  <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform duration-200"></i>
                </summary>
                <div className="px-5 pb-5 text-sm text-foreground-500 leading-relaxed">
                  我们尽力确保所收录内容的真实性，所有视频均来源于公开渠道。但由于网络信息的复杂性，我们建议用户理性看待，内容仅供娱乐参考。
                </div>
              </details>
              <details className="group bg-background-100 border border-background-300/60 rounded-lg overflow-hidden">
                <summary className="p-5 text-sm font-medium text-foreground-200 cursor-pointer hover:text-foreground-100 transition-colors duration-200 list-none flex items-center justify-between">
                  如果发现有侵权内容怎么办？
                  <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform duration-200"></i>
                </summary>
                <div className="px-5 pb-5 text-sm text-foreground-500 leading-relaxed">
                  如发现任何侵犯您权益的内容，请通过联系表单或邮件与我们取得联系，提供相关证明材料。我们将在核实后第一时间删除相关内容。
                </div>
              </details>
            </div>
          </section>
        </div>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}